import React, { PropsWithChildren, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import { useAppSettings } from '@/utils/appsettings/useAppSettings';

export const SentryWrapper = ({ children }: PropsWithChildren) => {
  const appSettings = useAppSettings();
  useEffect(() => {
    const enable = process.env.NODE_ENV === 'production';

    const current = Sentry.getClient();

    if (enable && !current && appSettings) {
      Sentry.init({
        dsn: 'https://f267ffc3a0ae84539b96813d2b3e1f70@o505679.ingest.sentry.io/4506422754279424',
        release: appSettings?.appVersion,
        environment: appSettings?.sentryEnvironment,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
            maskAllInputs: true,
          }),
          Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect: React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
          }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
        tracesSampleRate: 0.5,

        // Setting this option to true will print useful information to the console while you're setting up Sentry.
        debug: false,

        // Capture Replay for 10% of all sessions, plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1,

        normalizeDepth: 10,
      });
    }

    return () => {
      const client = Sentry.getClient();
      if (client) {
        client.close();
      }
    };
  }, [appSettings]);

  return <>{children}</>;
};
